import {ContentState} from '../../store';
import {Method} from '../constants';

export const initialContentState: ContentState = {
  init: false,
  form: {
    source: '', // used for reference on the BE
    source_uid: '',
    method: Method.APPEND,
    destination: '',
    schema: '',
  },
  tmpForm: null,
  isPreview: false,
}
